
import React, { useState, useEffect, memo, useRef } from 'react'
import styled from 'styled-components'
import Fab from '@material-ui/core/Fab'
import Icon from '@material-ui/core/Icon'
import { downloadPdf } from 'api'
import Button from '@material-ui/core/Button'
import ReactResizeDetector from 'react-resize-detector'

const Container = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  background: #8A8B94;
  padding: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 760px) {
    padding: 1rem;
  }
  ${({
    fullscreen
  }) => `
    ${fullscreen && `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
    `}
  `}
`

const PaperContainer = styled.div`
  flex: 1;
  max-width: ${props => props.maxSize}px;
`

const PaperRatio = styled.div`
  display: block;
  position: relative;
  height: 0;
  padding-bottom: 141.4%;
`

const IframeAbsoluteHolder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const StyledIframe = styled.iframe`
  border: none;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);
  transition: all 300ms linear 0ms;
  background: white;
`

const CustomIcon = styled(Icon)`
  font-size: 3rem;
  color: white;
`

const GenerateIcon = () => (<CustomIcon>cloud_download</CustomIcon>)

const GenerateButton = styled(Fab)`
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  width: 5rem;
  height: 5rem;
  background-color: #ff6900;
  ${({disable}) => `
    background-color: ${disable ? '#EC6100' : '#ff6900 !important'};
    &:hover {
      background-color: ${disable ? 'rgba(0, 0, 0, 0.3)' : 'rgba(33, 150, 243, 1)'};
    }
  `}
`

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.4);
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 5rem;
  font-weight: 400;
`

const FullscreenBttn = styled(Button)`
color: white !important;
bottom: 2rem;
background-color: #9B9EB4 !important;
  .MuiButtonBase-root {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    @media screen and (max-width: 1280px) {
      display: none;
    }
  }
`

const Preview = ({
  preview,
  requestData,
  formValid,
  id
}) => {
  const [state, setState] = useState({
    loading: false,
    maxSize: window.innerHeight/1.5
  })

  const [fullscreen, setFullscreen] = useState(false)
  const iframeRef = useRef(null)


  const resizeWindow = () => {
    requestAnimationFrame(() => {
      setState({
        ...state,
        maxSize: window.innerHeight/1.5
      })
    })
  }

  useEffect(() => {
    resizeWindow()
    window.addEventListener("resize", resizeWindow)
    return () => {
      window.removeEventListener("resize", resizeWindow)
    };
  }, [window.innerHeight])

  const setPreview = () => {
    let content = `
      <html>
          ${preview}
      </html>
    `
    const picture = requestData && requestData.picture ? requestData.picture : require('../img/avatar-preview.png');
    content = content.replace(/AVATAR-TO-CHANGE/g, picture)
    console.log('content', content)
    var iframeDocument = document.querySelector(`#${id}`).contentWindow.document;
    iframeDocument.open('text/html', 'replace');
    iframeDocument.write(content);
    iframeDocument.close();
  }

  useEffect(() => {
    setPreview()
  })

  const { maxSize, loading } = state

  // A4 format dimensions in pixels for 72 DPI
  // Preview html must be prepared in this dimensions
  const iframeHeight = 1431;
  const iframeWidth = 1082;

  return (
    <Container fullscreen={fullscreen}>
      <PaperContainer maxSize={maxSize}>
            <ReactResizeDetector  handleWidth handleHeight>
              {({ width, height }) =>
                <PaperRatio>
                  <IframeAbsoluteHolder>
                    <StyledIframe
                      id={id}
                      ref={iframeRef}
                      allowfullscreen=""
                      frameborder="0"
                      scrolling="yes"
                      marginheight='0'
                      marginwidth='0'
                      style={{
                        width: `${iframeWidth}px`,
                        height: `${iframeHeight}px`,
                        transformOrigin: '0px 0px',
                        transform: `scale(${width/iframeWidth}, ${height/iframeHeight})`
                      }}
                    />
                  </IframeAbsoluteHolder>
                </PaperRatio>
              }
            </ReactResizeDetector>
      </PaperContainer>
      <GenerateButton
        aria-label='Generate'
        onClick={async() => {
          setState({
            ...state,
            loading: true
          })
          await downloadPdf(requestData, formValid)
          setState({
            ...state,
            loading: false
          })
        }}
      >
          <GenerateIcon />
      </GenerateButton>
      <FullscreenBttn
        variant="contained"
        size="large"
        onClick={() => {
          setFullscreen(!fullscreen)
        }}
      >
        {fullscreen ? 'Zamknij pełny ekran' : 'Pełny ekran'}
      </FullscreenBttn>
      {loading && 
        <LoadingOverlay>Pobieranie</LoadingOverlay>
      }
    </Container>
  )
}

export default memo(Preview)
